import React from "react";
import Listar from "./Listar";
import authAxios from "../../services/Token";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
class Index extends React.Component {
	constructor(props) {
		super(props);
	}
	state = {
		enproceso: 0,
		congelado: 0,
		aprobado: 0,
		anulado: 0,
		contrato_no: 0,
		contrato_si: 0,
		cant_pro: 0,
		cant_mat: 0,
		ListaPqr: [],
	};
	dashboard() {
		Swal.showLoading();
		var idu = localStorage.getItem("idusuario");

		authAxios
			.get("configuracion/menu_principal/" + idu)
			.then((datosRespuesta) => {
				console.log(datosRespuesta);
				Swal.close();
				var status = datosRespuesta.data.status;
				var d = datosRespuesta.data;
				if (status) {
					Swal.fire("Token ha Expirado!", "Vuelva a Iniciar Sesión", "info");
					window.localStorage.clear();
					window.location.href = "/";
				}
				this.setState({
					cant_pro: d.result_pro,
					cant_mat: d.result_mat,
					enproceso: d.enproceso,
					congelado: d.congelado,
					aprobado: d.aprobado,
					anulado: d.anulado,
					contrato_no: d.contrato_no,
					contrato_si: d.contrato_si,
					ListaPqr: d.pqr,
				});
			})
			.catch(console.log);
	}
	componentDidMount() {
		this.dashboard();
	}
	render() {
		const {
			enproceso,
			congelado,
			aprobado,
			anulado,
			contrato_no,
			contrato_si,
			ListaPqr,
			cant_pro,
			cant_mat,
		} = this.state;
		return (
			<div>
				<div className="content-wrapper">
					<div className="content-header">
						<div className="container-fluid">
							<div className="row mb-2">
								<div className="col-sm-6">
									<h1 className="m-0">Dashboard</h1>
								</div>
								<div className="col-sm-6">
									<ol className="breadcrumb float-sm-right">
										<li className="breadcrumb-item">
											<a href="#">Home</a>
										</li>
										<li className="breadcrumb-item active">Dashboard v1</li>
									</ol>
								</div>
							</div>
						</div>
					</div>
					<section className="content">
						<div className="container-fluid">
							<div className="row">
								{/* <section className="col-lg-12 connectedSortable">
									<div className="card">
										<div className="card-header">
											<h3 className="card-title">
												En Construcción
											</h3>
										</div>

										<div className="card-body">
											
										</div>
										<div className="card-footer clearfix">
											&nbsp;
										</div>
									</div>
								</section> */}
								<div className="col-lg-3 col-6">
									<div className="small-box bg-danger">
										<div className="inner">
											<h3>{enproceso}</h3>
											<p>En proceso</p>
										</div>
										<div className="icon">
											<i className="ion ion-pie-graph" />
										</div>
										<a href="#" className="small-box-footer">
											Cotizaciones <i className="fas fa-arrow-circle-right" />
										</a>
									</div>
								</div>
								<div className="col-lg-3 col-6">
									<div className="small-box bg-danger">
										<div className="inner">
											<h3>{congelado}</h3>
											<p>Congeladas</p>
										</div>
										<div className="icon">
											<i className="ion ion-pie-graph" />
										</div>
										<a href="#" className="small-box-footer">
											Cotizaciones <i className="fas fa-arrow-circle-right" />
										</a>
									</div>
								</div>
								<div className="col-lg-3 col-6">
									<div className="small-box bg-danger">
										<div className="inner">
											<h3>{aprobado}</h3>
											<p>Aprobadas</p>
										</div>
										<div className="icon">
											<i className="ion ion-pie-graph" />
										</div>
										<a href="#" className="small-box-footer">
											Cotizaciones <i className="fas fa-arrow-circle-right" />
										</a>
									</div>
								</div>
								<div className="col-lg-3 col-6">
									<div className="small-box bg-danger">
										<div className="inner">
											<h3>{contrato_si}</h3>
											<p>Congeladas</p>
										</div>
										<div className="icon">
											<i className="ion ion-pie-graph" />
										</div>
										<a href="#" className="small-box-footer">
											Contratos <i className="fas fa-arrow-circle-right" />
										</a>
									</div>
								</div>
								<div className="col-lg-3 col-6">
									<div className="small-box bg-info">
										<div className="inner">
											<h3>{cant_pro}</h3>
											<p>Productos APU</p>
										</div>
										<div className="icon">
											<i className="ion ion-bag" />
										</div>
										<a href="#" className="small-box-footer">
											Productos <i className="fas fa-arrow-circle-right" />
										</a>
									</div>
								</div>
								<div className="col-lg-3 col-6">
									<div className="small-box bg-success">
										<div className="inner">
											<h3>{cant_mat}</h3>
											<p>Cantidad</p>
										</div>
										<div className="icon">
											<i className="ion ion-stats-bars" />
										</div>
										<a href="#" className="small-box-footer">
											Materiales <i className="fas fa-arrow-circle-right" />
										</a>
									</div>
								</div>
								<div className="col-lg-3 col-6">
									<div className="small-box bg-warning">
										<div className="inner">
											<h3>0</h3>
											<p>En construccion</p>
										</div>
										<div className="icon">
											<i className="ion ion-person-add" />
										</div>
										<a href="#" className="small-box-footer">
											Mas Informacion{" "}
											<i className="fas fa-arrow-circle-right" />
										</a>
									</div>
								</div>
								<div className="col-lg-3 col-6">
									<div className="small-box bg-danger">
										<div className="inner">
											<h3>0</h3>
											<p>En contruccion</p>
										</div>
										<div className="icon">
											<i className="ion ion-pie-graph" />
										</div>
										<a href="#" className="small-box-footer">
											Mas Informacion{" "}
											<i className="fas fa-arrow-circle-right" />
										</a>
									</div>
								</div>
							</div>
							{/* <div className="row">
								<section className="col-lg-6 connectedSortable">
									<div className="card direct-chat direct-chat-primary">
										<div className="card-header">
											<h3 className="card-title">En construccion</h3>
											<div className="card-tools">
												<span
													title="3 New Messages"
													className="badge badge-primary"
												>
													3
												</span>
												<button
													type="button"
													className="btn btn-tool"
													data-card-widget="collapse"
												>
													<i className="fas fa-minus" />
												</button>
												<button
													type="button"
													className="btn btn-tool"
													title="Contacts"
													data-widget="chat-pane-toggle"
												>
													<i className="fas fa-comments" />
												</button>
												<button
													type="button"
													className="btn btn-tool"
													data-card-widget="remove"
												>
													<i className="fas fa-times" />
												</button>
											</div>
										</div>
										<div className="card-body">
											<div className="direct-chat-messages">
												<div className="direct-chat-msg">
													<div className="direct-chat-infos clearfix">
														<span className="direct-chat-name float-left">
															Alexander Pierce
														</span>
														<span className="direct-chat-timestamp float-right">
															23 Jan 2:00 pm
														</span>
													</div>
													<img
														className="direct-chat-img"
														src="dist/img/user1-128x128.jpg"
														alt="message user image"
													/>
													<div className="direct-chat-text">
														Is this template really for free? That's
														unbelievable!
													</div>
												</div>
												<div className="direct-chat-msg right">
													<div className="direct-chat-infos clearfix">
														<span className="direct-chat-name float-right">
															Sarah Bullock
														</span>
														<span className="direct-chat-timestamp float-left">
															23 Jan 2:05 pm
														</span>
													</div>
													<img
														className="direct-chat-img"
														src="dist/img/user1-128x128.jpg"
														alt="message user image"
													/>
													<div className="direct-chat-text">
														You better believe it!
													</div>
												</div>
												<div className="direct-chat-msg">
													<div className="direct-chat-infos clearfix">
														<span className="direct-chat-name float-left">
															Alexander Pierce
														</span>
														<span className="direct-chat-timestamp float-right">
															23 Jan 5:37 pm
														</span>
													</div>
													<img
														className="direct-chat-img"
														src="dist/img/user1-128x128.jpg"
														alt="message user image"
													/>
													<div className="direct-chat-text">
														Working with AdminLTE on a great new app! Wanna
														join?
													</div>
												</div>
												<div className="direct-chat-msg right">
													<div className="direct-chat-infos clearfix">
														<span className="direct-chat-name float-right">
															Sarah Bullock
														</span>
														<span className="direct-chat-timestamp float-left">
															23 Jan 6:10 pm
														</span>
													</div>
													<img
														className="direct-chat-img"
														src="dist/img/user1-128x128.jpg"
														alt="message user image"
													/>
													<div className="direct-chat-text">
														I would love to.
													</div>
												</div>
											</div>
											<div className="direct-chat-contacts">
												<ul className="contacts-list">
													<li>
														<a href="#">
															<img
																className="contacts-list-img"
																src="dist/img/user1-128x128.jpg"
																alt="User Avatar"
															/>
															<div className="contacts-list-info">
																<span className="contacts-list-name">
																	Count Dracula
																	<small className="contacts-list-date float-right">
																		2/28/2015
																	</small>
																</span>
																<span className="contacts-list-msg">
																	How have you been? I was...
																</span>
															</div>
														</a>
													</li>
													<li>
														<a href="#">
															<img
																className="direct-chat-img"
																src="dist/img/user1-128x128.jpg"
																alt="message user image"
															/>
															<div className="contacts-list-info">
																<span className="contacts-list-name">
																	Sarah Doe
																	<small className="contacts-list-date float-right">
																		2/23/2015
																	</small>
																</span>
																<span className="contacts-list-msg">
																	I will be waiting for...
																</span>
															</div>
														</a>
													</li>
													<li>
														<a href="#">
															<img
																className="contacts-list-img"
																src="dist/img/user3-128x128.jpg"
																alt="User Avatar"
															/>
															<div className="contacts-list-info">
																<span className="contacts-list-name">
																	Nadia Jolie
																	<small className="contacts-list-date float-right">
																		2/20/2015
																	</small>
																</span>
																<span className="contacts-list-msg">
																	I'll call you back at...
																</span>
															</div>
														</a>
													</li>
													<li>
														<a href="#">
															<img
																className="contacts-list-img"
																src="dist/img/user5-128x128.jpg"
																alt="User Avatar"
															/>
															<div className="contacts-list-info">
																<span className="contacts-list-name">
																	Nora S. Vans
																	<small className="contacts-list-date float-right">
																		2/10/2015
																	</small>
																</span>
																<span className="contacts-list-msg">
																	Where is your new...
																</span>
															</div>
														</a>
													</li>
													<li>
														<a href="#">
															<img
																className="contacts-list-img"
																src="dist/img/user6-128x128.jpg"
																alt="User Avatar"
															/>
															<div className="contacts-list-info">
																<span className="contacts-list-name">
																	John K.
																	<small className="contacts-list-date float-right">
																		1/27/2015
																	</small>
																</span>
																<span className="contacts-list-msg">
																	Can I take a look at...
																</span>
															</div>
														</a>
													</li>
													<li>
														<a href="#">
															<img
																className="contacts-list-img"
																src="dist/img/user8-128x128.jpg"
																alt="User Avatar"
															/>
															<div className="contacts-list-info">
																<span className="contacts-list-name">
																	Kenneth M.
																	<small className="contacts-list-date float-right">
																		1/4/2015
																	</small>
																</span>
																<span className="contacts-list-msg">
																	Never mind I found...
																</span>
															</div>
														</a>
													</li>
												</ul>
											</div>
										</div>
										<div className="card-footer">
											<form action="#" method="post">
												<div className="input-group">
													<input
														type="text"
														name="message"
														placeholder="Type Message ..."
														className="form-control"
													/>
													<span className="input-group-append">
														<button type="button" className="btn btn-primary">
															Send
														</button>
													</span>
												</div>
											</form>
										</div>
									</div>
								</section>
								<section className="col-lg-6 connectedSortable">
									<div className="card">
										<div className="card-header">
											<h3 className="card-title">
												<i className="ion ion-clipboard mr-1" />
												PQR
											</h3>
										</div>

										<div className="card-body">
											<ul className="todo-list" data-widget="todo-list">
												{ListaPqr.map((item, i) => (
													<li>
														<span className="text">
															<span className="handle">
																<i className="fas fa-ellipsis-v" />
																<i className="fas fa-ellipsis-v" />
															</span>
															{item.OBSERVACIONES}
														</span>
														<small className="badge badge-danger">
															<i className="far fa-clock" />{" "}
															{item.FECHA_VENCIMIENTO}
														</small>
														<div className="tools">
															<Link to={"/UpPQR/" + item.ID_PQR}>
																<i className="fas fa-edit" />
															</Link>
														</div>
													</li>
												))}
											</ul>
										</div>
										<div className="card-footer clearfix">
											<button
												type="button"
												className="btn btn-primary float-right"
											>
												<i className="fas fa-plus" /> Add item
											</button>
										</div>
									</div>
								</section>
							</div> */}
						</div>
					</section>
				</div>
			</div>
		);
	}
}

export default Index;
